var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath fill='%2336dc90' d='M0 0h512v512H0z'/%3e%3cpath fill='white' fill-rule='nonzero' d='M228.9 404v-52.6H81v-52.9h109.8L91.5 201l38.5-37.5 98.9 97.3V109H283v152.1l99-97.2 38.4 37.4-99 97.2H431v53H283.1V404z'/%3e%3c/g%3e%3c/svg%3e";
  var avatar = img;

export { avatar as default };
//# sourceMappingURL=avatar.svg.js.map
